import { Suspense } from "react";
import { Box, Center, Loader, Stack } from "@mantine/core";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import Header from "../-components/MultiLocationHeader";

export const Route = createFileRoute("/_app/(multi-location)/admin")({
  beforeLoad: ({ context }) => {
    if (context.ability.cannot("manage", "MultiLocationView")) {
      redirect({ to: "/", throw: true });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Stack className="h-screen w-screen" gap={0}>
      {/* <MobileNavbar hiddenFrom="md" /> */}
      {/* <DesktopNavbar /> */}
      <Header />

      <Box style={{ overflowX: "hidden", flex: 1 }}>
        <Suspense
          fallback={
            <Center h="100%">
              <Loader />
            </Center>
          }
        >
          <Outlet />
        </Suspense>
      </Box>
    </Stack>
  );
}
